module.exports = __webpack_public_path__ + "img/ceres_logo_dark.684c3141.png";